import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringMentorsTab1Part } from './tabs/tab-1/volunteering-mentors-tab-1.part';
import { VolunteeringMentorsTab2Part } from './tabs/tab-2/volunteering-mentors-tab-2.part';
import { VolunteeringMentorsViewsPart } from './views/volunteering-mentors-views.part';
import { VolunteeringMentorsService } from './volunteering-mentors.service';

@Component({
	selector: 'volunteering-mentors-page',
	standalone: true,
	imports: [
		VolunteeringMentorsViewsPart,
		VolunteeringMentorsTab1Part,
		VolunteeringMentorsTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-mentors.page.html',
})
export class VolunteeringMentorsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringMentorsService);
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}